import React from "react";
import { createRoot } from "react-dom/client";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import "./index.sass";
import App from "./App";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container missing");
}

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
